// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1EJgl","consentsList":"PatientConsents_consentsList__2YkJR","consentsListEmpty":"PatientConsents_consentsListEmpty__R49Dd"};